import React, { Component , useState } from "react";
import Api from "../ServiceApi";
import { css } from "emotion";
import Cookies from "js-cookie";
import DynamicEditable from "./dynamic_edit_table";
import { connect } from "react-redux";
//import { changeLang } from "../../actions/langAction";
import { setDynamic } from "../../actions/dynamicAction";

import {
  Breadcrumb,
  Rate,
  Collapse,
  Form,
  Input,
  Modal,
  Table,
  Steps,
  Typography,
  Spin,
  Drawer,
  Tabs,
  Select,
  Radio,
  Checkbox,
  DatePicker,
} from "antd";
const { Column, ColumnGroup } = Table;
const { TabPane } = Tabs;
const { Option } = Select;

export class DynamicInput extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      condition_state: [],
      visibleDynamic: false,
      check:0,
      getJson:{},
      finalDynamic:[],
      backup:[],
      data_dynamic:{}
    };
  }

  async componentDidMount() {
    const full_url = window.location.href;
    let arr_url = full_url.split("/");
    const len = arr_url.length;
    let url_name = "";  
    let data_conf_master = {};
    let data_conf_dynamic = {};
    let page_id = 0;
    let dynamic_table_name = "";
    let condition = [];
    let temp_dynamic
    const { obj_val, data_item , page_name , setDynamic , dynamicReducer } = this.props;

    this.setState({
      backup : dynamicReducer.dynamic,
      state_dynamic : dynamicReducer.dynamic
    })

    // console.log(dynamicReducer.dynamic,'after dynamicReducer');
    // console.log(data_item["data_dynamic"],'data_dynamic');
    if(data_item["data_dynamic"] === undefined){
      // console.log('data_item undefined');
      temp_dynamic = dynamicReducer.dynamic
      setDynamic(dynamicReducer.dynamic,true)
    }else{
      // console.log('data_item setDynamic');
      if(typeof data_item["data_dynamic"] === 'string'){
        // console.log('data_dynamic is string');
        temp_dynamic = JSON.parse(data_item["data_dynamic"])
      }else{
        // console.log('data_dynamic is not string');
        temp_dynamic = data_item["data_dynamic"]
      }
      // console.log(temp_dynamic,'temp_dynamic');
      setDynamic(temp_dynamic,true)
      //setDynamic(data_item,true)
    }
    // console.log(dynamicReducer.dynamic,'after dynamic');
    //const jsonData = [{"company_id":1,"form_id":62,"key":62,"schema":"maxi_operation","module_name":"Maxi OPERATION","table_name":"oper_job","column_roles":"job_no","data_roles":"job_no=12","language":"EN,TH","language_name":"English,Thai","form_json":"{\"oper_job\": {\"0\": {\"input\": {\"id\": \"sl_type\", \"name\": \"sl_type\", \"type\": \"text\", \"class\": \"\", \"required\": false}, \"label\": {\"EN\": {\"for\": \"sl_type\", \"text\": \"sl_type\", \"class\": \"\"}, \"TH\": {\"for\": \"sl_type\", \"text\": \"ชนิด sl\", \"class\": \"\"}}}, \"1\": {\"input\": {\"id\": \"equipment_type\", \"name\": \"equipment_type\", \"type\": \"text\", \"class\": \"\", \"required\": false}, \"label\": {\"EN\": {\"for\": \"equipment_type\", \"text\": \"equipment_type\", \"class\": \"\"}, \"TH\": {\"for\": \"equipment_type\", \"text\": \"ประเภทของอุปกรณ์\", \"class\": \"\"}}}, \"2\": {\"label\": {\"EN\": {\"for\": \"data\", \"text\": \"data\", \"class\": \"\"}, \"TH\": {\"for\": \"data\", \"text\": \"ข้อมูล\", \"class\": \"\"}}, \"table\": {\"id\": \"data\", \"name\": \"data\", \"type\": \"colum\", \"class\": \"\", \"config\": {\"id\": 2, \"value\": 3, \"component\": [{\"language\": [{\"key\": \"EN\", \"text\": \"Impact_ID\"}, {\"key\": \"TH\", \"text\": \"ไอดี Impact\"}]}, {\"language\": [{\"key\": \"EN\", \"text\": \"Ins_Time\"}, {\"key\": \"TH\", \"text\": \"เวลาในการติดตั้ง\"}]}, {\"language\": [{\"key\": \"EN\", \"text\": \"Sys_Time\"}, {\"key\": \"TH\", \"text\": \"เวลาระบบ\"}]}]}, \"required\": false}}}}","output_json":"{\"table\": \"oper_job\", \"config_output\": [{\"label\": {\"EN\": {\"for\": \"sl_type\", \"text\": \"sl_type\", \"width\": 12}, \"TH\": {\"for\": \"sl_type\", \"text\": \"ชนิด sl\", \"width\": 12}, \"CSS\": {}}}, {\"label\": {\"EN\": {\"for\": \"equipment_type\", \"text\": \"equipment_type\", \"width\": 12}, \"TH\": {\"for\": \"equipment_type\", \"text\": \"ประเภทของอุปกรณ์\", \"width\": 12}, \"CSS\": {}}}, {\"label\": {\"EN\": {\"for\": \"data\", \"text\": \"data\", \"width\": 12}, \"TH\": {\"for\": \"data\", \"text\": \"ข้อมูล\", \"width\": 12}, \"CSS\": {}}, \"table\": {\"EN\": {\"columns\": [{\"key\": \"Impact_ID\", \"title\": \"Impact_ID\", \"dataIndex\": \"Impact_ID\"}, {\"key\": \"Ins_Time\", \"title\": \"Ins_Time\", \"dataIndex\": \"Ins_Time\"}, {\"key\": \"Sys_Time\", \"title\": \"Sys_Time\", \"dataIndex\": \"Sys_Time\"}]}, \"TH\": {\"columns\": [{\"key\": \"ไอดี Impact\", \"title\": \"ไอดี Impact\", \"dataIndex\": \"ไอดี Impact\"}, {\"key\": \"เวลาในการติดตั้ง\", \"title\": \"เวลาในการติดตั้ง\", \"dataIndex\": \"เวลาในการติดตั้ง\"}, {\"key\": \"เวลาระบบ\", \"title\": \"เวลาระบบ\", \"dataIndex\": \"เวลาระบบ\"}]}, \"CSS\": {}}}]}","value_json":"{\"data\": \"\", \"sl_type\": \"\", \"equipment_type\": \"\"}","effective_date":"01/09/2020","expire_date":null,"create_date":"14/09/2020","create_by":null,"update_date":"14/09/2020","update_by":null},{"company_id":1,"form_id":63,"key":63,"schema":"maxi_operation","module_name":"Maxi OPERATION","table_name":"oper_job","column_roles":"job_id","data_roles":"job_id=151","language":"EN,TH","language_name":"English,Thai","form_json":"{\"oper_job\": {\"0\": {\"input\": {\"id\": \"sl_type\", \"name\": \"sl_type\", \"type\": \"text\", \"class\": \"\", \"required\": false}, \"label\": {\"EN\": {\"for\": \"sl_type\", \"text\": \"sl_type\", \"class\": \"\"}, \"TH\": {\"for\": \"sl_type\", \"text\": \"ชนิด sl\", \"class\": \"\"}}}, \"1\": {\"input\": {\"id\": \"equipment_type\", \"name\": \"equipment_type\", \"type\": \"text\", \"class\": \"\", \"required\": false}, \"label\": {\"EN\": {\"for\": \"equipment_type\", \"text\": \"equipment_type\", \"class\": \"\"}, \"TH\": {\"for\": \"equipment_type\", \"text\": \"ประเภทของอุปกรณ์\", \"class\": \"\"}}}, \"2\": {\"label\": {\"EN\": {\"for\": \"data\", \"text\": \"data\", \"class\": \"\"}, \"TH\": {\"for\": \"data\", \"text\": \"ข้อมูล\", \"class\": \"\"}}, \"table\": {\"id\": \"data\", \"name\": \"data\", \"type\": \"colum\", \"class\": \"\", \"config\": {\"id\": 2, \"value\": 3, \"component\": [{\"language\": [{\"key\": \"EN\", \"text\": \"Impact_ID\"}, {\"key\": \"TH\", \"text\": \"ไอดี Impact\"}]}, {\"language\": [{\"key\": \"EN\", \"text\": \"Ins_Time\"}, {\"key\": \"TH\", \"text\": \"เวลาในการติดตั้ง\"}]}, {\"language\": [{\"key\": \"EN\", \"text\": \"Sys_Time\"}, {\"key\": \"TH\", \"text\": \"เวลาระบบ\"}]}]}, \"required\": false}}}}","output_json":"{\"table\": \"oper_job\", \"config_output\": [{\"label\": {\"EN\": {\"for\": \"sl_type\", \"text\": \"sl_type\", \"width\": 12}, \"TH\": {\"for\": \"sl_type\", \"text\": \"ชนิด sl\", \"width\": 12}, \"CSS\": {}}}, {\"label\": {\"EN\": {\"for\": \"equipment_type\", \"text\": \"equipment_type\", \"width\": 12}, \"TH\": {\"for\": \"equipment_type\", \"text\": \"ประเภทของอุปกรณ์\", \"width\": 12}, \"CSS\": {}}}, {\"label\": {\"EN\": {\"for\": \"data\", \"text\": \"data\", \"width\": 12}, \"TH\": {\"for\": \"data\", \"text\": \"ข้อมูล\", \"width\": 12}, \"CSS\": {}}, \"table\": {\"EN\": {\"columns\": [{\"key\": \"Impact_ID\", \"title\": \"Impact_ID\", \"dataIndex\": \"Impact_ID\"}, {\"key\": \"Ins_Time\", \"title\": \"Ins_Time\", \"dataIndex\": \"Ins_Time\"}, {\"key\": \"Sys_Time\", \"title\": \"Sys_Time\", \"dataIndex\": \"Sys_Time\"}]}, \"TH\": {\"columns\": [{\"key\": \"ไอดี Impact\", \"title\": \"ไอดี Impact\", \"dataIndex\": \"ไอดี Impact\"}, {\"key\": \"เวลาในการติดตั้ง\", \"title\": \"เวลาในการติดตั้ง\", \"dataIndex\": \"เวลาในการติดตั้ง\"}, {\"key\": \"เวลาระบบ\", \"title\": \"เวลาระบบ\", \"dataIndex\": \"เวลาระบบ\"}]}, \"CSS\": {}}}]}","value_json":"{\"data\": \"\", \"sl_type\": \"\", \"equipment_type\": \"\"}","effective_date":"01/09/2020","expire_date":null,"create_date":"14/09/2020","create_by":null,"update_date":"14/09/2020","update_by":null}]

    for (const [index, value] of arr_url.entries()) {
      if (index >= 3) {
        url_name += "/" + value;
      }
    } //end for

    const getConfMaster = await Api.post("get_page_config_master", {
      company_id: Cookies.get("companyid"),
      sql_where: " and page_path_name='" + url_name + "' and page_name='"+page_name+"'",
    });
    //console.log(getConfMaster,'getConfMaster');

    if (getConfMaster.data.result.code === "P") {
      data_conf_master =
        getConfMaster["data"]["data"]["page_config_master_list"][0] ? getConfMaster["data"]["data"]["page_config_master_list"][0] : [] ;
      page_id = data_conf_master.page_id;
    }

    const getConfDynamic = await Api.post("get_page_config_dynamic", {
      company_id: Cookies.get("companyid"),
      page_id: page_id,
      sql_where: " and obj_value='" + obj_val + "'",
    });
    //console.log(getConfDynamic,'getConfDynamic');

    if (getConfDynamic.data.result.code === "P") {
      data_conf_dynamic =
        // getConfDynamic["data"]["data"]["page_config_dynamic"][0];
        getConfDynamic["data"]["data"]["page_config_dynamic"][0] ? getConfDynamic["data"]["data"]["page_config_dynamic"][0] : [] ;
      dynamic_table_name = data_conf_dynamic.dynamic_table_name;
    }

    const jsonData = await Api.post("get_mas_form_json", {
      company_id: Cookies.get("companyid"),
      sql_where: " and table_name='" + dynamic_table_name + "'",
    });

    condition = jsonData["data"]["data"]["master_mas_from_json_list"];
    if(condition){
      this.setState({
        condition_state: condition,
        condition : condition
      });

      //console.log(condition,'condition');
      condition.map((field, index) => {
        //console.log(data_item,'data_item');
        if (data_item[field.column_roles] !== undefined) {
          let str = field.column_roles + "=" + data_item[field.column_roles];
          // console.log(str,'str');
          // console.log(field.data_roles,'data_roles');
          if (str === field.data_roles) {
            // check = 1;
            // getJson = field;
            this.setState({
              check:1,
              getJson:field
            })

            let set_dynamic = ""
            if(temp_dynamic){
              set_dynamic = temp_dynamic
            }else{
              set_dynamic = field["value_json"]
            }
            this.setState({
              finalDynamic : set_dynamic
            })

            setDynamic(set_dynamic,true)
          }
        }
      });


    }//end if
    
  }

  handleCancel(){
    const { dynamicReducer , setDynamic } = this.props;
    const { backup } =  this.state
    const dynamic = dynamicReducer.dynamic 
    setDynamic(backup,false)
  }

  handleSubmitDetail(values) {
    const { data_item , dynamicReducer , setDynamic } = this.props;
    const { finalDynamic , tableDynamic } =  this.state
    const dynamic = dynamicReducer.dynamic    

    Object.keys(values).map((result, currentKey) => {
      finalDynamic[result] = values[result]
    })

    // console.log(finalDynamic);
    setDynamic(finalDynamic,false)
  }

  handleDataTable(data, table) {
    const { data_item , setDynamic , dynamicReducer , finalDynamic} = this.props; 
    let dynamic = dynamicReducer.dynamic
    let arrDynamic = []
    if(typeof dynamic === 'string'){
     // console.log('is string');
      arrDynamic = JSON.parse(dynamic)
    }else{
      //console.log('not is string');
    }
    console.log(data,'data');
    arrDynamic[table] = data
    this.setState({
      finalDynamic : arrDynamic,
      tableDynamic : table
    })

    setDynamic(arrDynamic,false)
  }

  setFormsView(data) {
    const form_json = [];
    const form_json_parse = JSON.parse(data["form_json"]);
    for (let x in form_json_parse[data["table_name"]]) {
      form_json.push(form_json_parse[data["table_name"]][x]);
    }
    return form_json;
  }

  renderForms(getJson) {
    const { data_item, lang , setDynamic , dynamicReducer } = this.props;
    const { condition, dynamic_state , state_dynamic } = this.state;

    let dataJSON = {};
    let lang_name = lang.toUpperCase();
    let arrData = []

    // console.log(data_item,'data_item');
    // console.log(dynamicReducer.dynamic,'renderForms dynamic');
    const data_dynamic = (typeof dynamicReducer.dynamic === 'string')? JSON.parse(dynamicReducer.dynamic):dynamicReducer.dynamic
    //const data_dynamic = (data_item !== undefined)? JSON.parse(data_item["data_dynamic"]):[]
    // console.log(data_dynamic,'data_dynamic');
    const output_json = JSON.parse(getJson["output_json"]);
    dataJSON = output_json.config_output;
    
    getJson["forms"] = this.setFormsView(getJson);
    const forms = getJson["forms"];
    
    // console.log(data_dynamic,'dynamicReducer');
    // console.log(dynamicReducer.dynamic[field.table.id],'data_dynamic');
    // console.log(field.table.id,'field.table.id');
    
    return (
      <div>
        <Form
          onFinish={(values) => this.handleSubmitDetail(values)}
          layout="vertical"
          //initialValues={dynamicReducer.dynamic}
          initialValues={data_dynamic}
          //ref={(values) => this.handleSubmitDetail(values)}
        >
          <div className="row justify-content-center">
            <div className="col-12">
              {/* <Form layout="vertical"> */}
              {forms.map((field, index) => {
                if (field.input !== undefined) {
                  if (field.input["type"] === "radio") {
                    return (
                      <Form.Item
                        key={index}
                        name={field.label["EN"]["for"]}
                        label={field.label[lang_name]["text"]}
                        rules={[
                          {
                            required: field.input["required"],
                            message: `${field.label["EN"]["text"]} is required`,
                          },
                        ]}
                      >
                        <Radio.Group options={field.option} />
                      </Form.Item>
                    );
                  } else if (field.input["type"] === "checkbox") {
                    return (
                      <Form.Item
                        key={index}
                        name={field.label["EN"]["for"]}
                        label={field.label[lang_name]["text"]}
                        rules={[
                          {
                            required: field.input["required"],
                            message: `${field.label["EN"]["text"]} is required`,
                          },
                        ]}
                      >
                        <Checkbox.Group options={field.option} />
                      </Form.Item>
                    );
                  } else if (field.input["type"] === "date") {
                    return (
                      <Form.Item
                        key={index}
                        name={field.label["EN"]["for"]}
                        label={field.label[lang_name]["text"]}
                        rules={[
                          {
                            required: field.input["required"],
                            message: `${field.label["EN"]["text"]} is required`,
                          },
                        ]}
                      >
                        <DatePicker format="DD/MM/YYYY" />
                      </Form.Item>
                    );
                  } else if (field.input["type"] === "datetime-local") {
                    return (
                      <Form.Item
                        key={index}
                        name={field.label["EN"]["for"]}
                        label={field.label[lang_name]["text"]}
                        rules={[
                          {
                            type: "object",
                            required: field.input["required"],
                            message: `${field.label["EN"]["text"]} is required`,
                          },
                        ]}
                      >
                        <DatePicker showTime format="DD/MM/YYYY HH:mm:ss" />
                      </Form.Item>
                    );
                  } else if (field.input["type"] === "password") {
                    return (
                      <Form.Item
                        key={index}
                        name={field.label["EN"]["for"]}
                        label={field.label[lang_name]["text"]}
                        rules={[
                          {
                            type: "object",
                            required: field.input["required"],
                            message: `${field.label["EN"]["text"]} is required`,
                          },
                        ]}
                      >
                        <Input.Password
                          placeholder={`Please input ${field.label["EN"][
                            "text"
                          ].toLowerCase()}`}
                        />
                      </Form.Item>
                    );
                  } else {
                    return (
                      <Form.Item
                        key={index}
                        name={field.label["EN"]["for"]}
                        label={field.label[lang_name]["text"]}
                        rules={[
                          {
                            required: field.input["required"],
                            message: `${field.label["EN"]["text"]} is required`,
                          },
                        ]}
                      >
                        <Input
                          type={field.input["type"]}
                          className="font-mont-r fs-12"
                          size="large"
                          defaultValue={data_dynamic[field.label["EN"]["text"]]}
                          placeholder={`Please input ${field.label["EN"][
                            "text"
                          ].toLowerCase()}`}
                          // pattern={
                          //   field.input["pattern"] !== undefined
                          //     ? field.input["pattern"]
                          //     : ""
                          // }
                        />
                      </Form.Item>
                    );
                  }
                } else if (field.select !== undefined) {
                  const options = field.option.map((d) => (
                    <Option key={d.value}>{d.label}</Option>
                  ));
                  return (
                    <Form.Item
                      key={index}
                      name={field.label["EN"]["for"]}
                      label={field.label[lang_name]["text"]}
                      rules={[
                        {
                          required: field.select["required"],
                          message: `${field.select["text"]} is required`,
                        },
                      ]}
                    >
                      <Select
                        className="font-mont-r fs-12"
                        size="large"
                        placeholder={`Please select ${field.label["EN"][
                          "text"
                        ].toLowerCase()}`}
                      >
                        {options}
                      </Select>
                    </Form.Item>
                  );
                } else if (field.textarea !== undefined) {
                  return (
                    <Form.Item
                      key={index}
                      name={field.label["EN"]["for"]}
                      label={field.label[lang_name]["text"]}
                      rules={[
                        {
                          required: field.textarea["required"],
                          message: `${field.textarea["text"]} is required`,
                        },
                      ]}
                    >
                      <Input.TextArea />
                    </Form.Item>
                  );
                } else if (field.table !== undefined) {
                  let dynamic_col = [];
                  dataJSON.map((item, i) => {
                    if (item["label"][lang_name].for === field.table.id) {
                      dynamic_col = item["table"][lang_name]["columns"];
                    }
                  });

                  //console.log(JSON.parse(data_dynamic[field.table.id]),'DynamicEditable');
                  return (
                    <DynamicEditable
                      key={index}
                      col={dynamic_col}
                      table_id={field.table.id}
                      lang={lang}
                      //data_dynamic={data_dynamic[field.table.id]}
                      //data_dynamic={dynamicReducer.dynamic[field.table.id]}
                      data_dynamic={(typeof data_dynamic[field.table.id] === 'string')?JSON.parse(data_dynamic[field.table.id]):data_dynamic[field.table.id]}
                      parentUpdate={this.handleDataTable.bind(this)}
                    />
                  );
                }
              })}

              {/* </Form> */}
              {/* <Form.Item className="mb-0 text-center">
                        <div className="row">
                          <div className="col mt-2">
                            <button
                              type="reset"
                              onClick={() =>  this.handleCancel()}
                              className="btn btn-secondary mr-3"
                            >
                              Cancel
                            </button>
                            <button className="btn btn-success" >Submit</button>
                          </div>
                        </div>
                      </Form.Item> */}
            </div>
          </div>
        </Form>
      </div>
    );
  }

  render() {
    const { condition_state , check , getJson } = this.state;
    const { data_item } = this.props;

    return check ? this.renderForms(getJson) : null;
  }
}

const mapStateToProps = (state) => ({
  //lang: state.lang,
  dynamicReducer : state.dynamicReducer

});
const mapDispacthToProps = (dispatch) => {
  return {
    //changeLang: (data) => dispatch(changeLang(data)),
    setDynamic: (data,visible) => dispatch(setDynamic(data,visible)),
  };
};

export default connect(mapStateToProps, mapDispacthToProps)(DynamicInput);
//export default DynamicInput;
